export class AnnouncementRequestsModel {
  id: number;
  requestId: number;
  requestorId: number;
  requestorName: string;
  requestStatusName: string;
  requestNumber: string;
  requestStatusId: number;
  fmRequestType: string;
  companyName: string;
  announcementTitle: string;
  messageDetail: string;
  releaseDate: string;
  expirationDate: string;
  tenantNames: string[];
  tenantIds: number[];
  isFeedbackNeeded: boolean;
  hasAttachment: boolean;
  filesList: any[];
  isPushed: boolean;
}




// WEBPACK FOOTER //
// ./src/app/core/models/announcement-requests.ts